import Moment from 'moment/moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const dateFormat = 'DD/MM/YYYY';
const hourFormat = 'HH:mm';

export const fromStringToMoment = (d: string) => moment(d, dateFormat, true);

export const dateAndHourToMoment = (d: string, h: string | undefined) =>
  moment(`${d} ${h}`, `${dateFormat} ${hourFormat}`, true);
export const dateTimeToMoment = (dt: string) => moment(dt, `${dateFormat} ${hourFormat}`, true);
export const fromStringToDate = (d: string) => moment(d, dateFormat, true).toDate();
export const fromDateToString = (d: Date) => moment(d).format(dateFormat);

export const fromMomentToString = (m: Moment.Moment) => m.format(dateFormat);
